export default __webpack_public_path__ + "static/media/logo.e785ecf3.png";